import type { OpportunityForm } from '../components/OpportunityPageTypes';

function calendarDate(value: Date | null | undefined): string | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}
export function quoteProducts(form: OpportunityForm) {
  return form.products.map(product => ({
    product_id: product.productId,
    quantity: Number(product.quantity),
    price: Number(product.price),
    currency: product.currency,
    discount_type: product.discountType || 'percent',
    discount: Number(product.discountValue ?? product.discount ?? 0),
    package_id: product.salesPackageId || null,
    package_name: product.salesPackageName || '',
    payment_type: product.payment?.tipo || 'avista',
    payments: product.payment?.tipo === 'parcelado'
      ? (product.payment.parcelas || []).map(entry => ({ date: calendarDate(entry.data), amount: entry.amount ?? null, client_id: entry.client_id || null }))
      : [{ date: calendarDate(product.payment?.data), amount: null, client_id: product.payment?.client_id || null }],
  }));
}
